export const messageTypes = [
  {id: 'api_push_notification', label: 'Push Notification'},
  {id: 'api_automation', label: 'Automation'},
  {id: 'api_in-app_automation', label: 'In-App Automation'},
  {id: 'api_sequences_and_journeys', label: 'Sequences and Journeys'},
  {id: 'api_scenes', label: 'Scenes'},
  {id: 'api_surveys', label: 'Surveys'},
] as const
